import { apiProvider } from "@/services/utilities/Provider";

export const LeadService = {
    getByCampaign: (
        campaignId, page = 1, pageSize = 20, statuses = [], isFavourite = null, sortBy = null, sortDirection = null,
        search = null, includeTest = null, sources = [], dateFrom = null, dateTo = null, converted = null, interestLevels = []
    ) => {
        const params = new URLSearchParams({ page, pageSize });
        statuses.forEach(s => params.append('status', s));
        if (isFavourite) params.append('isFavorite', 'true');
        if (sortBy) params.append('sortBy', sortBy);
        if (sortDirection) params.append('sortDirection', sortDirection);
        if (search) params.append('search', search);
        if (includeTest) params.append('includeTest', 'true');
        sources.forEach(s => params.append('source', s));
        if (dateFrom) params.append('dateFrom', dateFrom);
        if (dateTo) params.append('dateTo', dateTo);
        if (converted !== null) params.append('converted', converted ? 'true' : 'false');
        interestLevels.forEach(l => params.append('interestLevel', l));
        return apiProvider.get(`/lead/campaign/${campaignId}?${params}`);
    },
    getSources: (campaignId) => apiProvider.get(`/lead/campaign/${campaignId}/sources`),
    getById: (id) => apiProvider.get(`/lead/${id}`),
    update: (id, lead) => apiProvider.put(`lead/${id}`, lead),
    toggleFavorite: (id) => apiProvider.patch(`lead/${id}/favorite`, {}),
    setInterestLevel: (id, interestLevel) => apiProvider.patch(`lead/${id}/interest-level`, { interestLevel }),
    changeStatus: (id, status, note = null, isAutomatic = false) =>
        apiProvider.patch(`lead/${id}/status`, { status, note, isAutomatic }),
    getNotes: (id, sortBy = null, sortDirection = null, search = null) => {
        const params = new URLSearchParams();
        if (sortBy) params.append('sortBy', sortBy);
        if (sortDirection) params.append('sortDirection', sortDirection);
        if (search) params.append('search', search);
        const qs = params.toString();
        return apiProvider.get(`/lead/${id}/notes${qs ? `?${qs}` : ''}`);
    },
    addNote: (id, content) => apiProvider.post(`lead/${id}/notes`, { content }),
    getTimeline: (id) => apiProvider.get(`/lead/${id}/timeline`),
    addTimelineEntry: (id, kind, description, occurredAt) =>
        apiProvider.post(`lead/${id}/timeline/entries`, { kind, description, occurredAt }),
    getInteractions: (leadId, page = 1, pageSize = 20) =>
        apiProvider.get(`/lead/${leadId}/interactions?page=${page}&pageSize=${pageSize}`),
    getAttachments: (id) => apiProvider.get(`/lead/${id}/attachments`),
    addAttachments: (id, files = []) => {
        const formData = new FormData();
        files.forEach(f => formData.append('files', f));
        return apiProvider.postMultipart(`lead/${id}/attachments`, formData);
    },
    downloadAllAttachmentsZip: (id) =>
        apiProvider.download(`/lead/${id}/attachments/zip`),
    downloadAttachment: (id, path) =>
        apiProvider.download(`/lead/${id}/attachments/file?name=${encodeURIComponent(path)}`),
};
